import React, { useState } from 'react';
import Button from '../../../../ui-core/Button/Button';
import { getItem, removeItem, setItem } from '../../../../utils/cache';
import { useDispatch } from 'react-redux';
import { MODAL_TYPE } from '../../../../constants/app';
import { doSendMergeOtpRequest } from '../../../../store/action/auth';
import PropTypes from 'prop-types';
import { useModal } from '../../../../context/ModalContext';

const ConfirmEmailModal = ({ handleModalState }) => {
  const [isLoading /* setIsLoading */] = useState(false);
  const dispatch = useDispatch();
  const mergeEmail = JSON.parse(getItem('mergeEmailDetail'))?.email;
  const { closeModal } = useModal();

  const handleSubmit = () => {
    setItem('AccountMerge', true);

    dispatch(
      doSendMergeOtpRequest({
        data: {
          type: 'email',
          email: mergeEmail,
        },
        callback: () => handleModalState(MODAL_TYPE.EMAIL_OTP),
      }),
    );
  };

  const handleCancel = () => {
    removeItem('AccountMerge');
    closeModal();
  };

  return (
    <div className="form-h">
      <h2 className="sign-in-h1">Confirm Email</h2>
      <p className="sign-in-h3 mb-4 mt-4 pb-3">
        An account with this email already exists. Please confirm your email to
        sync it with this account.
      </p>

      <div className="row">
        <div className="col-6">
          <Button
            text="NOT NOW"
            class={`OtpButton-outline m-0 ${isLoading && ''}`}
            isDisabled={isLoading}
            isLoading={isLoading}
            onClick={handleCancel}
          />
        </div>
        <div className="col-6">
          <Button
            text="CONTINUE"
            class={`OtpButton m-0 ${isLoading && ''}`}
            isDisabled={isLoading}
            isLoading={isLoading}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

ConfirmEmailModal.propTypes = {
  handleModalState: PropTypes.func.isRequired,
};

export default ConfirmEmailModal;
